import { track } from './api';
import { AppAction, AppState } from '../types';
import { QueryChangeDashboards } from '../components/CustomDashboard/actions';
import { ChangeStarredDashboard } from '../components/Dashboard/actions';
import { ResourcesValues } from '../components/ResourceSelector/actions';
import { RefreshChange, TimePickerChange } from '../components/TimePickerNavbar/actions';
import { LifecycleValues, SyncLifecycleValues } from '../lifecycle/lifecycle';
import { NotifyEvent } from '../components/Iframe/actions';
import { DownloadLogFile, AvailableFiles } from '../components/RawData/actions';
import { ChangeDateRange, ChangeSelectedType } from '../components/Reports/actions';
import { ActionType as LogPointsAPIActions } from '../components/LogPoints/LogPointsBody/LogPointsAPIsBody/actions'
import { ActionType as CloudHubActions } from '../components/Settings/Body/CloudHub/actions'
import { ActionType as BuiltInActions } from '../components/BuiltInDashboard/actions'
import { ActionType as RootActions } from '../components/root/actions'
import { ChangeSelectedServer, DownloadedInstaller } from '../components/Settings/Body/Hybrid/actions'
import { CreatedBasicAlert, CreatingBasicAlertError } from '../components/Alerts/AlertModals/BasicAlertModal/actions'
import { AlertChangedToggle, AlertsChangeColumnSort, AlertSearched, ChangeFilterValue } from '../components/Alerts/AlertsListPage/actions'

const metaVersion = document.querySelector('meta[name="artifact-version"]');
const metaDate = document.querySelector('meta[name="artifact-date"]');
export const artifact = {
  version: metaVersion && metaVersion.getAttribute('content'),
  date: metaDate && metaDate.getAttribute('content')
};

export const basicTransform = (state: AppState, action: AppAction) => ({
  type: action.type,
  artifact
});

export const payloadTransform = (state: AppState, action: any) => ({
  ...basicTransform(state, action),
  payload: action.payload || ''
});

const trackEvent = (type: string, alias: string,
                    transform: (state: AppState, action: AppAction) => any = payloadTransform,
                    transformAlias?: (type: any) => any) =>
  track(type, alias, transform, transformAlias);

export function registerActions() {
  // dashboards Actions
  trackEvent(TimePickerChange, 'Dashboard - Time change');
  trackEvent(RefreshChange, 'Dashboard - Manual refresh');

  // Custom dashboards Actions
  trackEvent(QueryChangeDashboards, 'Custom dashboard - Searching');
  trackEvent(ChangeStarredDashboard, 'Custom dashboard - Starred');

  // Builtin dashboards Actions
  trackEvent(ResourcesValues.SelectEnv, 'Builtin dashboard - Select Env');
  trackEvent(ResourcesValues.SelectApp, 'Builtin dashboard - Select App');
  trackEvent(ResourcesValues.SelectApi, 'Builtin dashboard - Select API');
  // trackEvent(ResourcesValues.ResourceDetailsLoaded, 'Builtin dashboard - APP details');
  trackEvent(BuiltInActions.ViewedAPIAnalytics, 'API Analytics Dashboard Viewed (Mainline)');
  trackEvent(BuiltInActions.ViewLogs, 'Builtin dashboard - Clicked "View Logs"');
  trackEvent(BuiltInActions.ManageAPI, 'Builtin dashboard - Clicked "Manage API"');
  trackEvent(BuiltInActions.ManageApplication, 'Builtin dashboard - Clicked "Manage Application"');
  trackEvent(BuiltInActions.ManageTarget, 'Builtin dashboard - Clicked "Manage Target"');
  trackEvent(BuiltInActions.ConfigureLogPoints, 'Builtin dashboard - Clicked "Configure Log Points"');
  trackEvent(BuiltInActions.SaveAs, 'Monitoring - Built In - Save as');
  trackEvent(BuiltInActions.SavedAsCustomDashboard, 'Monitoring - Built In - Saved successfully');
  // trackEvent(ResourcesValues.ApiDetailsLoaded, 'Builtin dashboard - Api details');
  
  // Alerts
  trackEvent(CreatedBasicAlert, 'Basic alerts - Created');
  trackEvent(CreatingBasicAlertError, 'Basic alerts - Creating alert error');
  trackEvent(AlertChangedToggle, 'Alerts - Enabled');
  trackEvent(ChangeFilterValue, 'Alert List - Filtered');
  trackEvent(AlertsChangeColumnSort, 'Alert List - Sort');
  trackEvent(AlertSearched, 'Alert List - Searched');

  // Raw data
  trackEvent(DownloadLogFile, 'Raw data download');
  trackEvent(AvailableFiles, 'Raw data available files');

  // Reports
  trackEvent(ChangeSelectedType, 'Reports selected type');
  trackEvent(ChangeDateRange, 'Reports date range changed');

  // Hybrid settings
  trackEvent(ChangeSelectedServer, 'Hybrid settings - selected server');
  trackEvent(DownloadedInstaller, 'Hybrid settings - downloaded installer');

  // CloudHub settings
  trackEvent(CloudHubActions.ChangedCloudHubSettingsCheckbox, 'CloudHub settings - Enable Monitoring by default');
  trackEvent(CloudHubActions.AmplitudeSuccess, 'CloudHub settings - Success');
  trackEvent(CloudHubActions.AmplitudeError, 'CloudHub settings - Error');

  // App
  trackEvent(LifecycleValues.Initialized, 'App - Initialized');
  trackEvent(LifecycleValues.InitializeError, 'App - Initialization Error');
  trackEvent(LifecycleValues.Initializing, 'App - Initializing');
  trackEvent(LifecycleValues.UnexpectedError, 'App - Unexpected Error');
  trackEvent(SyncLifecycleValues.InitializedSync, 'App - Initialized Sync');
  trackEvent(SyncLifecycleValues.InitializingSync, 'App - Initializing Sync');
  trackEvent(SyncLifecycleValues.InitializedSyncError, 'App - Initialized Sync Error');

  // Iframe
  trackEvent(
      NotifyEvent,
      'Iframe',
      payloadTransform,
      (data: any) => `${data.payload.type} - ${data.payload.event}`
  );

  // Log Points
  trackEvent(LogPointsAPIActions.SavingLogPoints, 'Log points API - Apply');

  // Screen resolution
  trackEvent(RootActions.ScreenSize, 'User screen resolution')
}

export const dashboardIframeEvents = [
  'pageview', 'init-edit-mode', 'panel-added',
  'dashboard-saved', 'dashboard-deleted'
];

export const logsIframeEvents = [
  'logs-query', 'remove-field', 'add-field',
  'save-search', 'clear-current-search', 'view-saved-searches',
  'add-filter', 'remove-filter',
  'view-log', 'view-surrounding-logs'
];
